<template>
    <st-dropdown-styled :toggle="toggle">
        <div class="st-dropdown-title" @mousedown="toggleHandler">
            <div><slot name="title" /></div>
            <awesome-icon name="sort-down" />
        </div>

        <transition name="st-drop-down-transition">
            <div v-if="toggle" class="st-dropdown-items">
                <slot name="dropdown-items">
                    <st-dropdown-item
                        v-for="(item, index) in items"
                        :key="index"
                        :label="item.label"
                        :handler="item.handler"
                    />
                </slot>
            </div>
        </transition>
    </st-dropdown-styled>
</template>
<script>
import styled, { css } from "vue-styled-components";
import StDropdownItem from "./StDropdownItem";

const props = {
    toggle: Boolean
};

const StDropdownStyled = styled("div", props)`
    position: relative;
    font-size: 1.6rem;
    user-select: none;

    .st-dropdown-title {
        height: 36px;
        line-height: 36px;

        display: flex;
        align-items: center;
        cursor: pointer;

        .awesome-icon {
            margin-left: 0.8rem;
            transition: all 0.3s;
            margin-top: -0.6rem;
            transform-origin: center;

            ${props =>
                props.toggle
                    ? css`
                          transform: rotateZ(-180deg) translateY(-6px);
                      `
                    : css`
                          transform: rotateZ(0deg) translateY(0px);
                      `}
        }
    }

    .st-dropdown-items {
        z-index: 9;
        position: absolute;
        right: 0;
        top: 100%;
        border-radius: 5px;
        border: 1px solid ${props => props.theme.color.line};
        overflow: hidden;
        cursor: pointer;

        display: flex;
        flex-direction: column;
        font-size: 1.4rem;
        word-break: break-all;
        white-space: nowrap;
    }
`;

export default {
    name: "StDropdown",
    data: () => ({
        toggle: false,
        dropdownEvent: null
    }),
    props: {
        items: Array
    },
    computed: {
        _toggle() {
            return !this.toggle;
        }
    },
    methods: {
        toggleHandler(env) {
            if (!this.toggle) {
                this.open();
            } else {
                this.close();
            }
        },

        close(isEvent) {
            this.toggle = false;
            this.dettachEventHandler();
        },

        open() {
            this.toggle = true;

            setTimeout(() => {
                this.attatchEventHandler();
            }, 0);
        },

        dettachEventHandler() {
            if (this.dropdownEvent) {
                document.removeEventListener("mousedown", this.dropdownEvent);
                this.dropdownEvent = null;
            }
        },

        attatchEventHandler() {
            if (!this.dropdownEvent) {
                this.dropdownEvent = () => {
                    if (!this._toggle) this.close();
                };
            }

            document.addEventListener("mousedown", this.dropdownEvent);
        }
    },
    beforeDestroy() {
        // this.dettachEventHandler();
    },
    components: {
        StDropdownStyled,
        StDropdownItem
    }
};
</script>
